/**
 * Access to C_VALUES related server API
 * WARNING Copied from front. Not included to avoid dependencies
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map, tap, pipe, take } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ValuesService {
	private _updateData$ = new BehaviorSubject<void>(undefined);		// Osvervable that triggers an update. Unused for now
	private cache: { [key: string]: Observable<any> } = {}; 				// Cache as a dictionary of observables

  constructor(private http: HttpClient) { }
  
	public getValues$(server_url: string, id:any):Observable<any> {	// Get cached values
		if (this.cache[id]) {											// Values in cache
			//console.log(`ValuesService: #${id}  found in cache`);
			return this.cache[id];
		}
		//console.log(`ValuesService: #${id} cache miss!`);
		const ret$ = this._updateData$.pipe(	// Cache miss. Get values from API call
			switchMap(() => this.http.get<void>(server_url + `/common/values/${id}`)),
			shareReplay(1),
			take(1)
		);
		this.cache[id]=ret$;		// Put value in cache
		return ret$;	
  }
}
